import React from 'react';
import {
    TouchableOpacity,
    Text,
    Image,
    StyleSheet,
    ViewStyle,
} from 'react-native';
import { COLORS } from '../../theme/themeTokens';

interface BackButtonProps {
    onPress: () => void;
    label?: string;
    showLabel?: boolean;
    iconVariant?: 'dark' | 'white';
    style?: ViewStyle;
}

const BackButton: React.FC<BackButtonProps> = ({
    onPress,
    label = 'Back',
    showLabel = true,
    iconVariant = 'dark',
    style,
}) => {
    const handlePress = () => {
        onPress();
    };

    const isWhite = iconVariant === 'white';

    return (
        <TouchableOpacity style={[styles.backButton, style]} onPress={handlePress} activeOpacity={0.7}>
            <Image
                source={
                    isWhite
                        ? require('../../assets/arrow_left_20_white.png')
                        : require('../../assets/arrow_left_20.png')
                }
                style={styles.backIcon}
            />
            {showLabel && (
                <Text style={[styles.backText, isWhite && styles.backTextWhite]}>{label}</Text>
            )}
        </TouchableOpacity>
    );
};

const styles = StyleSheet.create({
    backButton: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 8,
        marginBottom: 10,
        paddingVertical: 12,
        paddingRight: 16,
    },
    backText: {
      fontFamily: 'Inter',
      fontSize: 16,
      fontWeight: '500',
      lineHeight: 22,
        color: COLORS.deepNavy,
    },
    backTextWhite: {
      fontFamily: 'Inter',
      fontSize: 16,
      fontWeight: '500',
      lineHeight: 22,
        color: COLORS.white,
    },
    backIcon: {
        width: 18,
        height: 18,
    },
});

export default BackButton;
